import VerifySsnError from 'features/reactivation/challenges/VerifySsn/VerifySsnError';
import React from 'react';

export default function VerifySsnErrorPage() {
  return <VerifySsnError />;
}
